import { render } from "./AllMedicationPharmacies.vue?vue&type=template&id=9d2c9052&scoped=true"
import script from "./AllMedicationPharmacies.vue?vue&type=script&lang=js"
export * from "./AllMedicationPharmacies.vue?vue&type=script&lang=js"

import "./AllMedicationPharmacies.vue?vue&type=style&index=0&id=9d2c9052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2c9052"]])

export default __exports__